// extracted by mini-css-extract-plugin
export default {"tab":"tab_tab__l5FDP","tab__count":"tab_tab__count__BvxZq"};